import { useMemo } from 'react';
import {
  LineChart as MuiLineChart,
  LineChartProps,
} from '@mui/x-charts/LineChart';
import { calculateYAxisWidth } from '../../../utils/chart-utils';

export const LineChart = ({ yAxis, series, ...props }: LineChartProps) => {
  const enhancedYAxis = useMemo(() => {
    // If yAxis is not provided at all, preserve the default behavior of MuiLineChart.
    if (!yAxis) return yAxis;

    // Use the first provided axis config if present, otherwise create a sensible default.
    const baseAxis = yAxis[0] ?? {
      valueFormatter: (value: unknown) =>
        value === null || value === undefined ? '' : String(value),
    };

    const calculatedWidth = calculateYAxisWidth(
      series,
      baseAxis.valueFormatter,
    );

    // Respect caller-provided width, use calculated width only as fallback when positive
    const finalWidth =
      baseAxis.width ?? (calculatedWidth > 0 ? calculatedWidth : undefined);

    return [{ ...baseAxis, width: finalWidth }, ...yAxis.slice(1)];
  }, [yAxis, series]);

  return <MuiLineChart {...props} yAxis={enhancedYAxis} series={series} />;
};
